import React, { useState, useEffect, forwardRef } from "react";
import MaterialTable from "material-table";

import DateFnsUtils from "@date-io/date-fns";

import { MuiPickersUtilsProvider, KeyboardDatePicker } from "@material-ui/pickers";
import FormControl from "@material-ui/core/FormControl";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

import Button from "components/CustomButtons/Button.js";
import GridItem from "components/Grid/GridItem.js";

import Loader from "components/Loader/Loader";

import dashboardStyle from "assets/jss/material-dashboard-react/views/dashboardStyle.js";

import moment from "moment";
import "moment/locale/es";

import { Redirect } from 'react-router-dom';

const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

moment.locale("es");

export default function ReporteCapturaInvex() {
  
  const useStyles = makeStyles(theme => ({
    ...dashboardStyle,
    cardTitle: {
      marginTop: "0",
      minHeight: "auto",
      fontWeight: "300",
      fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
      marginBottom: "3px",
      textDecoration: "none"
    },
    select: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      color: "#D2D2D2",
      fontWeight: "400",
      fontSize: "14px",
      lineHeight: "1.42857",
      letterSpacing: "unset",
      "&:before": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      },
      "&:after": {
        borderColor: "#D2D2D2",
        fontWeight: "400",
        fontSize: "14px",
        lineHeight: "1.42857",
        letterSpacing: "unset"
      }
    },
    container: {
      textAlign: "center"
    },
    content: {
      display: "inline-flex",
      padding: "10px",
      alignItems: "center"
    },
    paddingBottomCard: {
      paddingBottom: "40px"
    },
    marginRight: {
      marginRight: "10px"
    },
    marginBottom: {
      marginBottom: "50px"
    },
    formControl: {
      marginTop: theme.spacing(3.5),
      minWidth: "100%"
    },
    formControl2: {
      minWidth: "100%",
      marginTop: theme.spacing(5)
    },
    selectEmpty: {
      marginTop: theme.spacing(2)
    }
  }));

  const classes = useStyles();

  const [selectFechaInicio, setSelectedFechaInicio] = useState(new Date());
  const [selectFechaFin, setSelectedFechaFin] = useState(new Date());

  const [load, setLoad] = useState(false);

  const [color, setColor] = useState("");
  const [message, setMessage] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);

  const [columnReporte] = useState([
    { title: "Nombre", field: "Nombre", type: "string" },
    { title: "Correo", field: "Correo", type: "string" },
    { title: "Teléfono", field: "Telefono", type: "string" },
    { title: "RFC", field: "RFC", type: "string" },
    { title: "Marca Dispositivo", field: "MarcaDispositivo", type: "string" },
    { title: "Modelo Dispositivo", field: "ModeloDispositivo", type: "string" },
    { title: "Version App", field: "VersionApp", type: "string" },
    { title: "Version SO", field: "VersionSO", type: "string" },
    { title: "Sistema Operativo", field: "SistemaOperativo", type: "string" },
    { title: "Estatus Error", field: "EstatusError", type: "string" },
    { title: "Estatus Flujo", field: "EstatusFlujo", type: "string" },
    { title: "Pasos Ejecutados", field: "PasosEjecutados", type: "string" },
    { title: "Estatus Incidencia", field: "EstatusIncidencia", type: "string" },
    { title: "Capturista", field: "Capturista", type: "string" },
    { title: "Fecha Capturista", field: "FechaCapturista", type: "string" },
  ]);

  const [reporte, setReporte] = useState([]);

  const sendSnackBar = (pmessage, pcolor) => {
    setOpenSnackbar(true);
    setColor(pcolor);
    setMessage(pmessage);
  };
  
  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const convertToCSV = (objArray) => {
    const array = typeof objArray != "object" ? JSON.parse(objArray) : objArray;
    let str = "";

    for (let i = 0; i < array.length; i++) {
        let line = "";

        for (let index in array[i]) {
            if (line !== "") line += ",";
            line += array[i][index];
        }

        str += line + "\r\n";
    }

    return str;
  };

  const exportCSVFile = (headers, items, fileName) => {
    if (headers) {
        items.unshift(headers);
    }

    const jsonObject = JSON.stringify(items);
    const csv = convertToCSV(jsonObject);
    const exportName = fileName + ".csv" || "export.csv";
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });

    if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, exportName);
    } else {
        const link = document.createElement("a");
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute("href", url);
            link.setAttribute("download", exportName);
            link.style.visibility = "hidden";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }
  };

  const exportData = (JSONData) => {
    let arrData = typeof JSONData != "object" ? JSON.parse(JSONData) : JSONData;
    let reportTitle = "Reporte_Invex";
    let headers = {};

    arrData = arrData.map(item => { 
      return { 
        Fecha: item.Fecha.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Hora: item.Hora.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Nombre: item.Nombre.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Correo: item.Correo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Telefono: item.Telefono.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        RFC: item.RFC.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        MarcaDispositivo: item.MarcaDispositivo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        ModeloDispositivo: item.ModeloDispositivo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        VersionApp: item.VersionApp.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        VersionSO: item.VersionSO.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        SistemaOperativo: item.SistemaOperativo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        EstatusError: item.EstatusError.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        EstatusFlujo: item.EstatusFlujo.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        PasosEjecutados: item.PasosEjecutados.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        EstatusIncidencia: item.EstatusIncidencia.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        Capturista: item.Capturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
        FechaCapturista: item.FechaCapturista.replaceAll(/(\r\n|\n|\r)/gm, "").replaceAll(",", "").replaceAll(`"`, "").replaceAll(`#`, ""),
      };
    });

    headers = {
        Fecha: "Fecha",
        Hora: "Hora",
        Nombre: "Nombre",
        Correo: "Correo",
        Telefono: "Telefono",
        RFC: "RFC",
        MarcaDispositivo: "Marca Dispositivo",
        ModeloDispositivo: "Modelo Dispositivo",
        VersionApp: "Version App",
        VersionSO: "Version SO",
        SistemaOperativo: "Sistema Operativo",
        EstatusError: "Estatus Error",
        EstatusFlujo: "Estatus Flujo",
        PasosEjecutados: "Pasos Ejecutados",
        EstatusIncidencia: "Estatus Incidencia",
        Capturista: "Capturista",
        FechaCapturista: "Fecha Capturista",
    };
    
    exportCSVFile(headers, arrData, reportTitle);
  };

  const handeSubmit = event => {
    event.preventDefault();
    try{
        setLoad(true);

        let fechaInicio = moment(selectFechaInicio);
        fechaInicio.set({h: 0, m: 0, s: 0});

        let fechaFin = moment(selectFechaFin);
        fechaFin.set({h: 23, m: 59, s: 59});

        Login()
        .then(result => {
            if (result !== undefined) {
                let body = {
                    FechaInicio: fechaInicio.format("YYYY/MM/DD HH:mm:ss"),
                    FechaFin: fechaFin.format("YYYY/MM/DD HH:mm:ss"),
                };

                ObtieneReporteIncidentes(body, result.token)
                .then(result => {
                      let capturas = result.reportes.map((element) => {
                        element.FechaCapturista = element.FechaCapturista === "" ? "" : moment(moment(element.FechaCapturista, process.env.REACT_APP_FECHA).toDate()).format("DD-MM-YYYY HH:mm:ss");
                        
                        return element;
                      });
                    setReporte(capturas);
                    setLoad(false);
                });
            } else {
                sendSnackBar("Error de conexión", "error");
                setLoad(false);
            }
        }).catch(error => sendSnackBar("Error de conexión", "error"));
    } catch(error){
        sendSnackBar("Error de conexión", "error");
        setLoad(false);
    }
  };

  const ObtieneReporteIncidentes = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "CapturaIncidencia/ObtieneReporteIncidentes",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  const Login = async () => {
      let dataResponse;
      try {
          let header = {
              method: "POST",
              body: JSON.stringify({UserName: process.env.REACT_APP_USER, Password: process.env.REACT_APP_PASS}),
              headers: {
                  "Content-Type": "application/json"
              }
          };

          let response = await fetch(
              process.env.REACT_APP_URL_APICORE + "Login",
              header
          );

          dataResponse = await response.json();
      } catch (error) {
          sendSnackBar("Error de conexión", "error");
      }

      return dataResponse;
  };

  const GetIdUsuario = () => {
    return JSON.parse(localStorage.getItem('userICR')).IdUsuario;
  };

  const UsuarioActivo = async (data, token) => {
    let dataResponse;
    try {
        let header = {
            method: "POST",
            body: JSON.stringify(data),
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + token
            }
        };

        let response = await fetch(
            process.env.REACT_APP_URL_APICORE + "Usuario/UsuarioActivo",
            header
        );

        dataResponse = await response.json();
    } catch (error) {
        sendSnackBar("Error de conexión", "error");
    }

    return dataResponse;
  };

  useEffect(() => {
    Login()
    .then(result => {
      let token = result.token;

      if(result !== undefined) {
        UsuarioActivo({ IdUsuario: GetIdUsuario() },token)
        .then(result => {
          console.log(result);
          if(result.activo === false){
            localStorage.removeItem("userICR");
            return <Redirect to='/admin'/>;
          }
        });
      } else {
        sendSnackBar("Error de conexión", "error");
      }
    });
  }, []);

  return (
    <div>
      <MuiPickersUtilsProvider utils={DateFnsUtils}>
        <Grid className={classes.marginBottom}>
          <Grid container className={classes.paddingBottomCard}>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <KeyboardDatePicker
                  format="yyyy/MM/dd"
                  margin="normal"
                  id="date-picker-inline"
                  label="Fecha inicio"
                  value={selectFechaInicio}
                  onChange={(date) => setSelectedFechaInicio(date)}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                />
              </FormControl>
            </GridItem>
            <GridItem xs={12} sm={12} md={4}>
              <FormControl className={classes.formControl}>
                <KeyboardDatePicker
                  margin="normal"
                  id="date-picker-dialog"
                  label="Fecha Final"
                  format="yyyy/MM/dd"
                  value={selectFechaFin}
                  onChange={(date) => setSelectedFechaFin(date)}
                  KeyboardButtonProps={{
                    "aria-label": "change date"
                  }}
                />
              </FormControl>
            </GridItem>
          </Grid>
          <GridItem xs={12} sm={12} md={2}>
            <Button
              onClick={e => {
                handeSubmit(e);
              }}
              color="info"
            >
              Buscar
            </Button>
          </GridItem>
        </Grid>
      </MuiPickersUtilsProvider>
      <MaterialTable
        title="Reporte Invex"
        columns={columnReporte}
        data={reporte}
        options={{
          exportButton: true,
          exportCsv: (columns, data) => {
            exportData(data);
          }
        }}
      ></MaterialTable>
        <Snackbar anchorOrigin={{ vertical: "bottom", horizontal: "right" }} open={openSnackbar} onClose={handleClose} autoHideDuration={6000}>
            <Alert onClose={handleClose} severity={color} sx={{ width: '100%' }}>
                {message}
            </Alert>
        </Snackbar>
        <Loader load={load} />
    </div>
  );
}